// extracted by mini-css-extract-plugin
export default {"container":"hcn1r","deleteIcon":"sL8Ll","icon":"dhJc1","image":"fb9RR","large":"HYHR9"};